import { cn } from "@/lib/utils";
import * as React from "react";

const SheetBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  // -mx-1 + px-1 keeps content at its original horizontal offset (matches
  // SheetContent's p-6 design spec), while widening the scroll clip box by
  // 4px on each side so focus rings on inputs/selects inside don't get
  // sliced — overflow-y-auto silently promotes overflow-x to auto per CSS
  // spec, which would otherwise clip box-shadow-based ring-* utilities.
  <div
    className={cn("-mx-1 flex-1 overflow-y-auto px-1", className)}
    {...props}
  />
);

SheetBody.displayName = "SheetBody";

export default SheetBody;
